import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'm-badge',
  templateUrl: './m-badge.component.html',
  styleUrls: ['./m-badge.component.scss'],
  host: {
    class: 'flex items-center'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MBadgeComponent {
  label = input<string>();
  styleClass = input<string>('');
}
